import React, { useContext, useLayoutEffect, useState } from "react";

export type DriverColumnNestExpandValue = {
  open: boolean;
  version: number;
};

export const DriverColumnNestExpandContext = React.createContext<DriverColumnNestExpandValue>({
  open: false,
  version: 0,
});

/**
 * Keeps nested stop/collapsible state in sync with parent expand/collapse-all controls.
 */
export function useNestedExpandSync(): [boolean, React.Dispatch<React.SetStateAction<boolean>>] {
  const { open: parentOpen, version } = useContext(DriverColumnNestExpandContext);
  const [open, setOpen] = useState(false);

  useLayoutEffect(() => {
    setOpen(parentOpen);
  }, [version, parentOpen]);

  return [open, setOpen];
}
